import * as Yup from "yup";
import documentoFreteNfeValidator from "./documento-frete-nfe.validator";

const documentoFreteListaNfeValidator = Yup.array()
  .of(documentoFreteNfeValidator)
  .min(1, "Adicione pelo menos uma NF-e")
  .required();

export default documentoFreteListaNfeValidator;
